module.exports = __webpack_public_path__ + "static/media/YF41_2.d4156165.jpg";